module.exports = __webpack_public_path__ + "img/Not_Result.a03da9b8.png";